import { post } from 'utils/sdk';

export const setSelfUserPassword = ({
  token,
  email,
  password,
  passwordConfirmation,
}: {
  token: string;
  email: string;
  password: string;
  passwordConfirmation: string;
}) =>
  post<{ message: string }>('api/v2/auth/set-password', {
    token,
    email,
    password,
    password_confirmation: passwordConfirmation,
  });

export const resetSelfUserPassword = ({ token, email, password }: { token: string; email: string; password: string }) =>
  post('api/v2/auth/reset-password', {
    token,
    email,
    password,
    password_confirmation: password,
  });

export const isUserTokenValid = ({ email, token }: { email: string; token: string }) =>
  post('api/v2/auth/is-user-token-valid', {
    token,
    email,
  });

export const sendForgotPasswordEmail = ({ email }: { email: string }) =>
  post('api/v2/auth/send-forgot-password-email', {
    email,
  });
